import { useUserProfileData } from "./utils/useUserProfileData";
import { isUserIdsIncluded } from "./utils/isUserIdsIncluded";
import { TEAMS_MANAGED_BY_ORGANIZATION } from "./helpers";
import { selectorIsImpersonatedWingspanAdmin } from "../FocusedFeatures/Dashbaord/selectors/selectorIsImpersonatedWingspanAdmin";

export const useTeamsManagedByOrganization = () => {
  const userData = useUserProfileData();

  // Impersonating admins bypass the external-management lockout.
  if (selectorIsImpersonatedWingspanAdmin()) {
    return false;
  }

  const isTeamsManagedByOrganization = isUserIdsIncluded(
    userData,
    TEAMS_MANAGED_BY_ORGANIZATION
  );

  return isTeamsManagedByOrganization;
};
